import React from 'react';

// Small colored status dot — replaces color-coded emoji (🔴🟠🟡🟢🔵🟣⚫⚪) across the app.
const StatusDot: React.FC<{ color: string; className?: string }> = ({color, className}) => (
   <span className={`inline-block w-2 h-2 rounded-full shrink-0 ${className ?? ''}`} style={{background: color}} />
);

export default StatusDot;
